import { render, staticRenderFns } from "./SolutionStats.vue?vue&type=template&id=0cca8d51&"
import script from "./SolutionStats.vue?vue&type=script&lang=js&"
export * from "./SolutionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports